export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQSection {
  title: string;
  items: FAQItem[];
}

export const faqSections: FAQSection[] = [
  {
    title: 'IT Support & Services',
    items: [
      {
        question: 'What is your response time for IT support requests?',
        answer: 'We guarantee a 15-minute response time for all support requests, 24/7. Our local Treasure Valley team is always on standby to assist with any IT emergency or question. For critical issues, we typically have a technician working on your problem within minutes of your call.'
      },
      {
        question: 'Do you offer on-site IT support in the Treasure Valley?',
        answer: 'Yes, we provide on-site IT support throughout the Treasure Valley including Meridian, Boise, Nampa, Eagle, Caldwell, Kuna, and surrounding areas. Our technicians are local and can be at your location quickly when remote support isn\'t sufficient.'
      },
      {
        question: 'What size businesses do you typically work with?',
        answer: 'We specialize in serving small to medium-sized businesses with 5-50 employees. This focus allows us to provide personalized, high-quality IT support tailored to the specific needs of growing businesses in the Treasure Valley.'
      },
      {
        question: 'Can you help with both Mac and Windows computers?',
        answer: 'Absolutely. Our technicians are experienced with both Windows and Mac environments. We can support mixed environments and help you choose the best solutions for your specific business needs.'
      }
    ]
  },
  {
    title: 'Network & Cabling',
    items: [
      {
        question: 'Do you install network cabling for new offices?',
        answer: 'Yes, we are licensed low-voltage contractors (License #3171776) specializing in structured cabling installations. We handle Cat6/Cat6a ethernet cabling, fiber optic installations, and complete network infrastructure for new construction and office buildouts throughout the Treasure Valley.'
      },
      {
        question: 'Can you help if my business internet is slow or unreliable?',
        answer: 'Definitely. We diagnose network performance issues and implement solutions including proper cabling, upgraded switches, optimized router configurations, and managed network services with automatic 5G failover to ensure your business stays connected.'
      },
      {
        question: 'What is structured cabling and does my business need it?',
        answer: 'Structured cabling is a standardized approach to network infrastructure that organizes cables, patch panels, and connections in a logical, scalable way. If your business has more than 5 employees or plans to grow, structured cabling provides reliability, easier troubleshooting, and room for expansion.'
      },
      {
        question: 'Do you provide network rack installation and organization?',
        answer: 'Yes, we design and install professional network racks including cable management, patch panels, switches, and documentation. Proper rack organization improves airflow, simplifies maintenance, and extends equipment life.'
      }
    ]
  },
  {
    title: 'UniFi & WiFi Solutions',
    items: [
      {
        question: 'What is UniFi and why do you recommend it?',
        answer: 'UniFi is a professional-grade networking solution by Ubiquiti that offers enterprise features at an affordable price point. We recommend UniFi because it provides reliable WiFi coverage, easy management, security cameras, and access control all in one integrated system - perfect for Treasure Valley businesses.'
      },
      {
        question: 'Can you install UniFi systems in my existing building?',
        answer: 'Yes, we handle complete UniFi installations including site surveys, access point placement, cabling, camera installation, and system configuration. We work with existing infrastructure and can upgrade your network without major disruption to your business.'
      },
      {
        question: 'Do you provide ongoing UniFi support and management?',
        answer: 'We offer both one-time installations and ongoing managed services for UniFi networks. With our managed service, we monitor your network 24/7, apply updates, and proactively address issues before they impact your business.'
      }
    ]
  },
  {
    title: 'Cybersecurity',
    items: [
      {
        question: 'How do you protect businesses from ransomware and cyber threats?',
        answer: 'We implement multiple layers of security including endpoint protection, email filtering, DNS security, employee training, regular backups, and 24/7 monitoring. Our security-first approach helps prevent attacks and ensures you can recover quickly if an incident occurs.'
      },
      {
        question: 'Do you offer security assessments for businesses?',
        answer: 'Yes, we provide comprehensive cybersecurity assessments that evaluate your current security posture, identify vulnerabilities, and provide actionable recommendations. We also offer a free online security checklist to help you understand your risk level.'
      },
      {
        question: 'What should I do if I think my business has been hacked?',
        answer: 'Contact us immediately at (208) 328-4500. Time is critical during a security incident. We offer emergency response services and can help contain the threat, assess the damage, recover your systems, and implement measures to prevent future attacks.'
      },
      {
        question: 'Do you help with compliance requirements like HIPAA?',
        answer: 'Yes, we help businesses implement IT systems and policies that support compliance with HIPAA, PCI-DSS, and other regulatory requirements. This includes secure configurations, access controls, encryption, backup procedures, and documentation.'
      }
    ]
  },
  {
    title: 'Microsoft 365 & Cloud',
    items: [
      {
        question: 'Can you help migrate my business to Microsoft 365?',
        answer: 'Absolutely. We handle complete Microsoft 365 migrations including email transfer, data migration, user setup, and training. We ensure a smooth transition with minimal downtime and help you get the most value from your Microsoft 365 subscription.'
      },
      {
        question: 'What Microsoft 365 plans do you recommend for small businesses?',
        answer: 'For most Treasure Valley small businesses, we recommend Microsoft 365 Business Premium. It includes Office apps, email, Teams, SharePoint, and essential security features like advanced threat protection at a reasonable per-user cost.'
      },
      {
        question: 'Do you provide Microsoft 365 administration and support?',
        answer: 'Yes, we offer ongoing Microsoft 365 administration including user management, security configuration, backup, troubleshooting, and optimization. Our team can serve as your outsourced IT department for all things Microsoft.'
      }
    ]
  },
  {
    title: 'Pricing & Getting Started',
    items: [
      {
        question: 'How much does IT support cost for a small business?',
        answer: 'Our managed IT services start at $150/month per user for comprehensive support, monitoring, and security. We also offer project-based pricing for one-time needs like network installations or migrations. Contact us for a custom quote based on your specific needs.'
      },
      {
        question: 'Do you offer free consultations?',
        answer: 'Yes, we offer free initial consultations to understand your business needs and provide recommendations. There\'s no obligation, and you\'ll get honest advice about whether our services are a good fit for your situation.'
      },
      {
        question: 'What is included in your managed IT services?',
        answer: 'Our All-Inclusive Care plan includes 24/7 monitoring, unlimited remote support, on-site visits when needed, cybersecurity protection, backup management, vendor coordination, and strategic IT planning. Everything you need for complete IT peace of mind.'
      },
      {
        question: 'How quickly can you onboard a new client?',
        answer: 'We typically complete new client onboarding within 1-2 weeks. This includes network assessment, security review, system documentation, monitoring setup, and user training. For urgent situations, we can expedite the process.'
      }
    ]
  }
];
